export enum DocumentStatusEnum {
  PENDENTE = 1,
  ENVIADO = 2,
  OK = 3,
  CORRECAO = 4,
}

export const descricaoStatusDocumento: Record<DocumentStatusEnum, string> = {
  [DocumentStatusEnum.PENDENTE]: 'Pendente',
  [DocumentStatusEnum.ENVIADO]: 'Enviado',
  [DocumentStatusEnum.OK]: 'Confirmar',
  [DocumentStatusEnum.CORRECAO]: 'Correção',
};
